export default "__VITE_ASSET__BUeACf5Z__"